import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Replaces Angular's default ErrorHandler so every uncaught error (component
 * creation, template, lifecycle, router, unhandled promise inside the zone) is
 * logged with a consistent, searchable prefix plus the unwrapped original error
 * and its stack. Never swallows: it only logs.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const original = unwrap(error);
    // eslint-disable-next-line no-console
    console.error('[cornerstone] Uncaught error:', original);
    if (original !== error) {
      // eslint-disable-next-line no-console
      console.error('[cornerstone] Wrapped error:', error);
    }
  }
}

/** Unwrap zone "Uncaught (in promise)" wrappers to the real error. */
function unwrap(error: any): any {
  let current = error;
  for (let i = 0; i < 5 && current; i++) {
    const next = current.rejection ?? current.ngOriginalError ?? current.originalError;
    if (!next || next === current) break;
    current = next;
  }
  return current;
}
